var DocumentModel = require("@immanens-com/pv5js/reader/models/document-model");

/**
 * BndDocumentModel : modèle de document pour la bnd, contient les données de l'enregistrement elastic en plus des données standard de document pv
 */

module.exports = DocumentModel.extend({
    
    defaults: {
        subtitle: null
    },

    urlRoot: function () {
        return this.pv5api + "/bnd-document/" + this.get("publicationId");
    }

});



//////////////////
// WEBPACK FOOTER
// ./src/models/bnd-document-model.js
// module id = 37
// module chunks = 0